import React, { useState, useMemo } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Select,
  Col,
  Row,
  Popconfirm,
  Space,
  DatePicker,
} from "antd";
import { ReactComponent as DeleteIcon } from "../../../../../assets/delete-icon.svg";
import { ReactComponent as CrossIcon } from "../../../../../assets/crossIcon.svg";
import { ReactComponent as SaveIcon } from "../../../../../assets/circular-save-btn.svg";
import moment from "moment";
import { stockTakeFilterOptions } from "../../../utils";

const { Option } = Select;

const DistributionFieldsComponent = ({
  inputFields,
  setInputFields,
  createField,
  deleteField,
  updateField,
  canUpdate,
}) => {
  const currentFilterOptions = stockTakeFilterOptions;

  const handleDeleteLocally = (item) => {
    const filteredInputs = inputFields.filter((el) => el.id !== item.id);
    setInputFields(filteredInputs);
  };

  const addChooseField = () => {
    let field = {
      isEdit: true,
      name: "",
      isLocal: true,
      id: Math.floor(Math.random() * 10000000),
      label: "Select Field",
      placeholder: "Select Field",
      isSelect: true,
    };
    setInputFields([...inputFields, { ...field }]);
  };

  const handleChangeField = (value, ele, option) => {
    const { index } = ele;

    let fields = [...inputFields];
    fields[index] = {
      ...ele,
      // id: value,
      value,
      option,
    };
    setInputFields(fields);

    // Automatically create the field when a value is selected
    // createField({ ...fields[index], name: '' });
  };

  const handleCreateField = (item) => {
    createField({ ...item, name: '' });
  };

  const handleDisable = (value) => {
    let item = inputFields.filter((el) => el.value === value && !el.isSelect);

    let shuoldDisabled = item.length > 0 ? true : false;

    return shuoldDisabled;
  };

  const SelectOption = ({ placeholder, ele }) => (
    <Select
      style={{ display: "block" }}
      placeholder={placeholder}
      size="small"
      dropdownClassName="filter-select-dropdown"
      getPopupContainer={() =>
        document.getElementsByClassName(
          "ant-layout-content layout-content site-layout-background custom-textarea"
        )[0]
      }
      disabled={!canUpdate}
      onChange={(e, option) => handleChangeField(e, ele, option)}
      value={ele?.value || null}
    >
      {currentFilterOptions.map((el) => {
        const { value, label } = el;
        return (
          <Option value={value} key={value} disabled={handleDisable(value)}>
            {label}
          </Option>
        );
      })}
    </Select>
  );

  const RenderFieldTypes = ({ item, localName, setLocalName }) => {
    const { placeholder, value, index } = item;

    if (value === "distribution_date") {
      return (
        <DatePicker
          format={"DD MMM YYYY"}
          size="small"
          allowClear={false}
          suffixIcon={null}
          placeholder={"Select Date"}
          value={localName}
          disabled={!canUpdate}
          onChange={(e) => {
            setLocalName(moment(e));
            inputFields[index].name = moment(e);
            setInputFields(inputFields);
            updateField({ ...item, name: moment(e) });
          }}
        />
      );
    }

    return (
      <Input
        placeholder={`${placeholder}`}
        value={localName}
        disabled={!canUpdate}
        onChange={(e) => {
          const { value } = e.target;
          setLocalName(value);
          inputFields[index].name = value;
          setInputFields(inputFields);
        }}
        onBlur={() => {
          updateField({ ...item, name: localName });
        }}
      />
    );
  };

  const RenderReadOnlyFields = ({ item }) => {
    let { value, name } = item;

    if (value === "distribution_date") {
      name = moment(name).format("DD MMM YYYY");
    }

    return (
      <Input size="small" className="border-less-input" readOnly value={name} />
    );
  };

  const RenderInputs = ({ ele }) => {
    const { isEdit, label, placeholder, name, value } = ele;
    const [localName, setLocalName] = useState(name);

    return (
      <Row
        align="bottom"
        justify="start"
        className="field-row"
        gutter={[15, 0]}
      >
        <Col span={18}>
          <label>{label}</label>
          {ele?.isEdit ? (
            ele?.isSelect ? (
              <SelectOption placeholder={placeholder} ele={ele} />
            ) : (
              <RenderFieldTypes
                item={ele}
                localName={localName}
                setLocalName={setLocalName}
              />
            )
          ) : (
            <RenderReadOnlyFields item={ele} />
          )}
        </Col>
        {canUpdate && (
          <Col>
            {isEdit ? (
              <Space size={10} align="baseline">
                {ele?.isSelect ? (
                  <Space size={10} align="baseline" style={{ display: "flex", gap: "10px" }}>
                    <div style={{ cursor: "pointer" }} onClick={() => handleCreateField(ele)}>
                      <SaveIcon />
                    </div>
                    <Popconfirm
                      title={"Are you sure you want to cancel?"}
                      placement="topRight"
                      onConfirm={() => handleDeleteLocally(ele)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <CrossIcon />
                    </Popconfirm>
                  </Space>
                ) : (
                  <Popconfirm
                    title={"Are you sure you want to delete?"}
                    placement="topRight"
                    onConfirm={() => handleDeleteLocally(ele)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteIcon width={16} height={16} fill="#ed017f" />
                  </Popconfirm>
                )}
              </Space>
            ) : (
              <Space size={10} align="baseline">
                {/* <EditIcon onClick={() => onEditClick(ele)} /> */}
                <Popconfirm
                  title="Are you sure you want to delete?"
                  placement="topRight"
                  onConfirm={() => deleteField(ele)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteIcon width={16} height={16} fill="#ed017f" />
                </Popconfirm>
              </Space>
            )}
          </Col>
        )}
      </Row>
    );
  };

  return (
    <Row gutter={[20, 0]} className="custom-fields-parent-div">
      {inputFields.map((el, i) => {
        return (
          <Col span={24} key={`item-${el.id}`} index={i}>
            <RenderInputs ele={{ ...el, index: i }} />
          </Col>
        );
      })}
      {canUpdate && (
        <Col span={24}>
          <Button
            onClick={addChooseField}
            icon={<PlusOutlined />}
            size="small"
            className="add-field-btn"
          >
            Filter
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default DistributionFieldsComponent;
